import styled from "styled-components"
import { Color } from "../../styles/palette"

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || Color.greenLight};
  box-shadow: 0 16px 30px rgba(0, 78, 100, 30%);
`;
